import * as lodash from "lodash";

const OutsideClickPlugin = {
    install(Vue) {
        let handleOutsideClick;

        Vue.directive("click-outside", {
            bind(el, binding, vnode) {
                handleOutsideClick = (e) => {
                    const { exclude, handler } = binding.value;
                    const matchingClassName = lodash.intersection(exclude, e.target.classList);

                    if (!el.contains(e.target) && matchingClassName.length === 0) {
                        vnode.context[handler]();
                    }
                };
                document.addEventListener("click", handleOutsideClick);
                document.addEventListener("touchstart", handleOutsideClick);
            },

            unbind() {
                document.removeEventListener("click", handleOutsideClick);
                document.removeEventListener("touchstart", handleOutsideClick);
            },
        });
    },
};

export default OutsideClickPlugin;
